import { LogLevel } from './log-level.enum';

export class LogEntry {
    public extraInfo: any[];
    public level: LogLevel;
    public message: string;
    public timestamp = new Date();

    constructor(message: string, level: LogLevel, extraInfo: any[]) {
        this.extraInfo = extraInfo;
        this.level = level;
        this.message = message;
    }

    public toString = (): string => {
        let value = `Time: ${new Date()} - Type: ${LogLevel[this.level]} - Message: ${this.message}`;

        if (this.extraInfo.length) {
            value += ` - Extra Info: ${this.formatParams(this.extraInfo)}`;
        }

        return value;
    }

    private formatParams(params: any[]): string {
        const delimiter = ', ';

        if (params.some(p => typeof (p) === 'object')) {
            let value = '';
            params.forEach((item, index) => {
                value += JSON.stringify(item);

                if (index < params.length - 1) {
                    value += delimiter;
                }
            });

            return value;
        }

        return params.join(delimiter);
    }
}
